import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RmaRequestModel } from 'src/app/shared/models/rma.model';

@Component({
  selector: 'app-shipping-information-step',
  templateUrl: './shipping-information-step.component.html',
  styleUrls: ['./shipping-information-step.component.css']
})
export class ShippingInformationStepComponent implements OnInit {
  @Input() rmarequest : RmaRequestModel;
  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedShipping : string;
  constructor() { 
    this.selectedShipping = "1";
  }

  ngOnInit() {
  }
  onNext()
  {
    console.log(this.selectedShipping);
    if(this.selectedShipping == "1")
    {
      var address = this.rmarequest.client.address + "\n"
       + this.rmarequest.client.provinceCode + "," + this.rmarequest.client.countryCode +  "\n"
       + this.rmarequest.client.zipCode;

      this.rmarequest.rma.shippingAddress = address;
    }

    this.onNextStep.emit(this.rmarequest);
  }

  onBack()
  {
    this.onPrevStep.emit(this.rmarequest);
  }
}
